import React from 'react';
import { useSeenModulePixel } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { AUTO_INSURANCE_FOR_CREDIT_SCORE_INCREASE } from 'types/morph.pagePosition.constants';
import { useLinkHandler } from 'hook/event.hook';
import AutoInsuranceForCreditScoreIncreaseModuleView from './AutoInsuranceForCreditScoreIncreaseModuleView';
const AutoInsuranceForCreditScoreIncrease = props => {
  const atr = getViewModuleTrackingAttributes({
    pagePosition: AUTO_INSURANCE_FOR_CREDIT_SCORE_INCREASE,
    modulePosition: props.modulePosition,
    vertical: 'Auto Insurance',
  });
  const seenPixel = useSeenModulePixel(atr);
  const onLinkClick = useLinkHandler(props.eventHandler);

  return (
    <AutoInsuranceForCreditScoreIncreaseModuleView
      {...props}
      seenPixel={seenPixel}
      onLinkClick={onLinkClick}
    />
  );
};

export default AutoInsuranceForCreditScoreIncrease;
